import { Country } from '@skin-seoul/service';

export interface Threshold {
  freeShipping: number;
  tenPercentOff: number;
}

export const thresholdsPerCountry: Record<Country, Threshold> = {
  [Country.UnitedStates]: { freeShipping: 49, tenPercentOff: 70 },
  [Country.Australia]: { freeShipping: 55, tenPercentOff: 90 },
  [Country.NewZealand]: { freeShipping: 60, tenPercentOff: 90 },
  [Country.Canada]: { freeShipping: 69, tenPercentOff: 100 },
  [Country.UnitedKingdom]: { freeShipping: 45, tenPercentOff: 60 },
  [Country.Singapore]: { freeShipping: 49, tenPercentOff: 80 },
  [Country.Malaysia]: { freeShipping: 170, tenPercentOff: 260 },
  [Country.UnitedArabEmirates]: { freeShipping: 180, tenPercentOff: 250 },
  [Country.SaudiArabia]: { freeShipping: 220, tenPercentOff: 300 },
  [Country.Qatar]: { freeShipping: 215, tenPercentOff: 290 },
};
